<div class="container-fluid font-color-navy container-shadow">
  <span *ngIf="isListloading" class="justify-content-center">
    <app-loading [displayeMessage]="true"></app-loading>
  </span>

  <ng-container *ngIf="!isEditable">
    <div class="button-row float-right">
      <span *ngIf="isListloading==false">
        <app-refresh (click)="ngOnInit()" [buttonDisplay]="true"></app-refresh>
      </span>
      <span *ngIf="isListloading==true">
        <app-refresh [buttonDisplay]="false"></app-refresh>
      </span>
      <button style="float:right;" mat-icon-button matTooltip="Edit Task" (click)="onEditClick()" [disabled]="!canModify" [ngClass]="canModify?'font-color-orange':'color-disabled'" aria-label="Edit Task">
        <mat-icon aria-hidden="false" aria-label="Edit Task" fontIcon="edit_note"></mat-icon>
      </button>
    </div>
    <table class="table-new-design" *ngIf="!isEmptyList">
      <thead>
        <tr class="group myTasks-request-title font-color-white bold-text">
          <th>task Id</th>
          <th>title</th>
          <th>replies</th>
          <th>Short Type</th>
        </tr>
      </thead>
      <tbody *ngFor="let task of taskList;let i = index" id="accordionTaskDetails" class="accordion">
        <tr class="accordion-item background-darkGrey" [id]="'headingTaskDetails'+i">
          <td><button class="btn-new-ui-xs" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseTask'+i" aria-expanded="true" aria-controls="collapseTask">{{task.taskId}} </button></td>
          <td>{{task.title}}</td>
          <td>
            <ng-container *ngIf="task.taskStatistics.requestType == 0">
              <span style="width:25px;border-bottom:4px solid #5cb85c;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-approved context-menu" title="{{task.taskStatistics.approvedCount}} Approved"> {{task.taskStatistics.approvedCount}} </span></span>
              <span style="width:25px;border-bottom:4px solid #d9534f;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-rejected context-menu" title="{{task.taskStatistics.rejectedCount}} Needs more work"> {{task.taskStatistics.rejectedCount}} </span></span>
              <span style="width:25px;border-bottom:4px solid #D0E4B0;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-not-relevant context-menu" title="{{task.taskStatistics.notRelevantCount}} Not Relevant"> {{task.taskStatistics.notRelevantCount}} </span></span>
              <span style="width:25px;border-bottom:4px solid #5bc0de;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-reviewed context-menu" title="{{task.taskStatistics.reviewedCount}} Reviewed"> {{task.taskStatistics.reviewedCount}} </span></span>
              <span style="width:25px;border-bottom:4px solid #777;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-pending context-menu" title="{{task.taskStatistics.pendingCount}} Pending"> {{task.taskStatistics.pendingCount}} </span></span>
            </ng-container>

            <ng-container *ngIf="task.taskStatistics.requestType == 1">
              <span style="width:20px;border-bottom:4px solid #5cb85c;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-approved context-menu" title="{{task.taskStatistics.approvedCount}} Accepted"> {{task.taskStatistics.approvedCount}} </span></span>
              <span style="width:20px;border-bottom:4px solid #d9534f;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-rejected context-menu" title="{{task.taskStatistics.rejectedCount}} Rejected"> {{task.taskStatistics.rejectedCount}} </span></span>
              <span style="width:20px;border-bottom:4px solid #f0ad4e;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-could-not-test context-menu" title="{{task.taskStatistics.couldNotTestCount}} Could Not Test"> {{task.taskStatistics.couldNotTestCount}} </span></span>
              <span style="width:20px;border-bottom:4px solid #D0E4B0;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-not-relevant context-menu" title="{{task.taskStatistics.notRelevantCount}} Not Relevant"> {{task.taskStatistics.notRelevantCount}} </span></span>
              <span style="width:20px;border-bottom:4px solid #5bc0de;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-reviewed context-menu" title="{{task.taskStatistics.reviewedCount}} Reviewed"> {{task.taskStatistics.reviewedCount}} </span></span>
              <span style="width:20px;border-bottom:4px solid #777;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-pending context-menu" title="{{task.taskStatistics.pendingCount}} Pending"> {{task.taskStatistics.pendingCount}} </span></span>
            </ng-container>
          </td>
          <td><a href="{{task.requirementLink}}" target="_blank" style="cursor:pointer;">{{task.shortType}}</a></td>
        </tr>
        <tr [id]="'collapseTask'+i" class="accordion-collapse collapse" data-bs-parent="#accordionTaskDetails">
          <td colspan="4">
            <span [innerHtml]="task.description"></span>
            <app-requestorfeedback [taskId]="task.responseId" [canComment]="canModify"></app-requestorfeedback>
            <h3 class="font-color-navy bold-text background-lightGrey px-1">
              <span class="bold-text font-color-navy" style="font-size:20px !important">Reviewer(s) Status</span>
            </h3>
            <app-reviewerspertask [requestId]="requestId" [requirementId]="task.taskId"></app-reviewerspertask>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <ng-container *ngIf="isEditable">
    <br />
    <div>
      <span matAutocompleteOrigin #taskOrigin="matAutocompleteOrigin">
        <mat-form-field class="form-group">
          <input type="text" placeholder="Select task" [formControl]="addTaskControl" matInput [matAutocomplete]="autoTasks"
                 [matAutocompleteConnectedTo]="taskOrigin" class="form-control" required>
          <mat-autocomplete [panelWidth]="'auto'" #autoTasks="matAutocomplete" (optionSelected)="onAddTaskSelected($event)">
            <mat-option *ngFor="let option of tasksfilteredOptions | async" [value]="option.id">
              {{option.title}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
      <span class="font-color-orange" style="margin: 0 0 0 30px;">{{this.errorMessage}}</span>
      <span class="float-end">
        <button class="btn-new-ui-xs" style="margin: 0 20px 0 0;" (click)="onCancelClick()">Cancel</button>
        <button [ngClass]="isModified ? 'btn-new-ui-xs':'btn-new-ui-disabled'" (click)="onSaveClick()" [disabled]="!(canModify && isModified)">Save</button>
      </span>

    </div>
    <span *ngIf="isTaskLoading">
      <app-loading [displayeMessage]="false"></app-loading>
    </span>

    <table class="table table-bordered table-striped" id="modifiedTasks">
      <thead class="table-secondary">
        <tr>
          <th class="font-color-navy">ID</th>
          <th class="font-color-navy">TITLE</th>
          <th class="font-color-navy">TYPE</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let task of newTaskList; index as i" [attr.id]="task.id">
          <td>{{task.id}}</td>
          <td>{{task.title}}</td>
          <td>{{task.shortType}}</td>
          <td><button id="delete{{task.id}}" (click)="deleteTask(task)" [disabled]="!canModify" class="btn-new-ui-xs">Delete</button></td>
        </tr>
      </tbody>
    </table>
  </ng-container>

</div>
